const spiderTypes = {
  GET_MARCAS: "GET_MARCAS",
  GET_MARCAS_SUCCESS: "GET_MARCAS_SUCCESS",
  GET_MARCAS_FAILED: "GET_MARCAS_FAILED",
  GET_MODELOS: "GET_MODELOS",
  GET_MODELOS_SUCCESS: "GET_MODELOSSUCCESS",
  GET_MODELOS_FAILED: "GET_MODELOS_FAILED",
  GET_CHANNEL_REQUEST: "GET_CHANNEL_REQUEST",
  GET_CHANNEL_SUCCESS: "GET_CHANNEL_SUCCESS",
  GET_CHANNEL_FAILED: "GET_CHANNEL_FAILED",
}

export { spiderTypes };